import { Chip } from "@mui/material";

export default function AttributeChip({attribute, mobile}) {
  return <Chip label={attribute} sx={{color: "white", marginRight: 1, fontSize: mobile ? "16px" : "auto", backgroundColor: `rgb(${(attribute.charCodeAt(0)-50)*2}, ${(attribute.charCodeAt(0)-50)*4}, ${(attribute.charCodeAt(0)-50)*10})`}} />
}